import { ScriptGraph, ScriptModule } from "./callScripts.types";

// Module list — emoji icons and start nodes are structural (non-translatable).
// Titles/subs come from i18n (callScripts.modules.<id>).
export const MODULES: ScriptModule[] = [
  { id: "voll", icon: "🗺️", start: "s0" },
  { id: "gen", icon: "😤", start: "sG" },
  { id: "str", icon: "⏱️", start: "sS" },
  { id: "num", icon: "📞", start: "sN" },
  { id: "kre", icon: "💶", start: "sKF" },
  { id: "kei", icon: "🚪", start: "sKI" },
  { id: "auto", icon: "🚗", start: "sIS" },
];

// Full dialog graph, transcribed 1-to-1 from docs/remixed-0f596ace.html.
// Choice order matches the i18n choices array for each node, so the labels line up.
export const NODES: ScriptGraph = {
  // 1. OPENING
  s0: {
    id: "s0",
    hasCtx: true,
    hasTip: true,
    choices: [{ next: "sJB" }, { next: "sG" }, { next: "sS" }, { next: "sND" }],
  },

  // 2. "JA ICH BIN ES"
  sJB: {
    id: "sJB",
    hasCtx: true,
    hasProspect: true,
    hasTip: true,
    choices: [{ next: "sWB" }, { next: "sUW" }, { next: "sHZ" }, { next: "sN" }],
  },

  // 3. NICHT DA
  sND: {
    id: "sND",
    hasCtx: true,
    hasProspect: true,
    hasTip: true,
    choices: [{ next: "eC" }],
  },

  // 4. GENERVT
  sG: {
    id: "sG",
    hasCtx: true,
    hasProspect: true,
    hasTip: true,
    choices: [{ next: "sWB" }, { next: "sHZ" }, { next: "sN" }, { next: "sL" }],
  },

  // 5. WENIG ZEIT
  sS: {
    id: "sS",
    hasCtx: true,
    hasProspect: true,
    hasTip: true,
    choices: [{ next: "sIS" }, { next: "sI" }, { next: "sKI" }],
  },

  // 6. IM AUTO / BEI DER ARBEIT
  sIS: {
    id: "sIS",
    hasCtx: true,
    hasProspect: true,
    hasNote: true,
    hasTip: true,
    choices: [{ next: "eC" }, { next: "eN" }, { next: "sIShumor" }],
  },

  sIShumor: {
    id: "sIShumor",
    hasCtx: true,
    hasProspect: true,
    hasTip: true,
    choices: [{ next: "eC" }, { next: "eC" }],
  },

  // 7. WOHER NUMMER
  sN: {
    id: "sN",
    hasCtx: true,
    hasProspect: true,
    hasTip: true,
    choices: [{ next: "sI" }, { next: "sE" }, { next: "eN" }],
  },

  // 8. SKEPTISCH
  sE: {
    id: "sE",
    hasCtx: true,
    hasProspect: true,
    hasTip: true,
    choices: [{ next: "sWB" }, { next: "eN" }],
  },

  // 9. LANGWEILIG
  sL: {
    id: "sL",
    hasCtx: true,
    hasProspect: true,
    hasTip: true,
    choices: [{ next: "eN" }, { next: "sWB" }],
  },

  // 10. HAT ZEIT
  sHZ: {
    id: "sHZ",
    hasCtx: true,
    hasProspect: true,
    hasTip: true,
    choices: [{ next: "sWB" }, { next: "sUW" }],
  },

  // 11. WAS BIETEN SIE AN
  sWB: {
    id: "sWB",
    hasCtx: true,
    hasProspect: true,
    hasTip: true,
    choices: [{ next: "sKF" }, { next: "sI" }],
  },

  // 12. GEHT ES UM KREDITE
  sKF: {
    id: "sKF",
    hasCtx: true,
    hasProspect: true,
    hasTip: true,
    choices: [{ next: "sI" }, { next: "sKI" }],
  },

  // 13. UM WAS GEHT ES
  sUW: {
    id: "sUW",
    hasCtx: true,
    hasProspect: true,
    hasTip: true,
    choices: [{ next: "sI" }, { next: "sKI" }],
  },

  // 14. KEIN INTERESSE
  sKI: {
    id: "sKI",
    hasCtx: true,
    hasProspect: true,
    hasTip: true,
    choices: [{ next: "sI" }, { next: "eN" }],
  },

  // 15. INTERESSIERT — HAUPTPITCH
  sI: {
    id: "sI",
    hasCtx: true,
    hasProspect: true,
    hasTip: true,
    choices: [{ next: "eS" }, { next: "sSP" }, { next: "sSP" }],
  },

  // 16. SPÄTER
  sSP: {
    id: "sSP",
    hasCtx: true,
    hasProspect: true,
    hasTip: true,
    choices: [{ next: "eC" }],
  },

  // ENDINGS
  eS: { id: "eS", end: true, endType: "success" },
  eC: { id: "eC", end: true, endType: "callback" },
  eN: { id: "eN", end: true, endType: "negative" },
};
